import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Image from 'Image'

import css from './Loading.css'

const getImage = (fileName) => require(`media/images/${fileName}`) // eslint-disable-line global-require

const Loading = ({ className }) => (
  <Image media={getImage('Loading-Icon.gif')} className={classNames(css.gif, className)} />
)

Loading.propTypes = {
  className: PropTypes.string,
}

Loading.defaultProps = {
  className: null,
}

export default Loading
